export default {
    SET_LABOS: (state, data) => (state.labos = data),
};